// import {
//   BrowserRouter,
//   Routes,
//   Route,
//   Navigate,
// } from 'react-router-dom';

// import { Box } from '@mui/material';

// import MainLayout from './layout/MainLayout';
// import Dashboard from './pages/Dashboard';
// import LeadContent from './components/LeadContent';
// import AddLeadForm from './components/AddLeadForm';
// import InquiryDetails from './components/InquiryDetails';
// import CustomersPage from './components/CustomersPage';
// import Login from './pages/Login';

// // MASTER PAGES

// import BudgetDetails from './masters/BudgetDetails';
// import BudgetMasterForm from './masters/BudgetMasterForm';
// import CommunicationDetails from './masters/CommunicationDetails';
// import CommunicationMasterForm from './masters/CommunicationMasterForm';
// import CustomerDetails from './masters/CustomerDetails';
// import CustomerMasterForm from './masters/CustomerMasterForm';
// import EmployeeDetails from './masters/EmployeeDetails';
// import EmployeeMasterForm from './masters/EmployeeMasterForm';
// import PrimaryGoalDetails from './masters/PrimaryGoalDetails';
// import PrimaryGoalMasterForm from './masters/PrimaryGoalMasterForm';
// import PropertyTypeDetails from './masters/PropertyTypeDetails';
// import PropertyTypeMasterForm from './masters/PropertyTypeMasterForm';
// import SourceDetails from './masters/SourceDetails';
// import SourceMasterForm from './masters/SourceMasterForm';
// import TimelineDetails from './masters/TimelineDetails';
// import TimelineMasterForm from './masters/TimelineMasterForm';

// function App() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         {/* LOGIN */}

//         <Route path="/" element={<Login />}
//         />

//         {/* MAIN LAYOUT */}

//         <Route element={
//             <Box
//               sx={{
//                 border:
//                   '10px solid #1f0b7c',

//                 height: '100vh',

//                 boxSizing: 'border-box',
//               }}
//             >
//               <MainLayout />
//             </Box>
//           }
//         >
//           {/* DASHBOARD */}

//           <Route path="/dashboard" element={<Dashboard />}/>

//           {/* INQUIRY */}

//           <Route path="/inquiry" element={<AddLeadForm />}/>

//           {/* INQUIRY DETAILS */}

//           <Route path="/inquiry-details" element={<InquiryDetails />}/>

//           {/* CUSTOMERS */}

//           <Route path="/customers" element={<CustomersPage />}/>

//           {/* LEADS */}

//           <Route path="/leads" element={<LeadContent />} />

//           {/* BUDGET MASTER */}

//           <Route path="/budget-details" element={<BudgetDetails />}/>

//           <Route path="/budget-master" element={<BudgetMasterForm />}/>

//           {/* COMMUNICATION MASTER */}

//           <Route path="/communication-details" element={<CommunicationDetails />} />
//           <Route path="/communication-master" element={<CommunicationMasterForm />}/>

//   {/* Customer MASTER */}
//           <Route path="/customer-details" element={<CustomerDetails />} />
//           <Route path="/customer-master" element={<CustomerMasterForm />}/>


//          {/* Employee MASTER */}
//           <Route path="/employee-details" element={<EmployeeDetails />} />
//           <Route path="/employee-master" element={<EmployeeMasterForm />}/>

//           {/* PrimaryGoal MASTER */}
//           <Route path="/PrimaryGoal-details" element={<PrimaryGoalDetails />} />
//           <Route path="/PrimaryGoal-master" element={<PrimaryGoalMasterForm />}/>

//           {/*PropertyType MASTER */}
//           <Route path="/PropertyType-details" element={<PropertyTypeDetails />} />
//           <Route path="/PropertyType-master" element={<PropertyTypeMasterForm />}/>

//           {/*Source MASTER */}
//           <Route path="/Source-details" element={<SourceDetails />} />
//           <Route path="/Source-master" element={<SourceMasterForm />}/>

//          {/*Source MASTER */}
//           <Route path="/Timeline-details" element={<TimelineDetails />} />
//           <Route path="/Timeline-master" element={<TimelineMasterForm />}/>

          
//         </Route>

//         {/* DEFAULT */}

//         <Route
//           path="*"
//           element={<Navigate to="/" />}
//         />
//       </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { Box } from '@mui/material';

import MainLayout from './layout/MainLayout';
import Dashboard from './pages/Dashboard';
import LeadContent from './components/LeadContent';
import AddLeadForm from './components/AddLeadForm';
import InquiryDetails from './components/InquiryDetails';
import CustomersPage from './components/CustomersPage';
import ReportPage from './components/ReportPage';
import Login from './pages/Login';

// MASTER PAGES
import AreaDetails from './masters/AreaDetails';
import AreaMasterForm from './masters/AreaMasterForm';
import BudgetDetails from './masters/BudgetDetails';
import BudgetMasterForm from './masters/BudgetMasterForm';
import CommunicationDetails from './masters/CommunicationDetails';
import CommunicationMasterForm from './masters/CommunicationMasterForm';
import CustomerDetails from './masters/CustomerDetails';
import CustomerMasterForm from './masters/CustomerMasterForm';
import EmployeeDetails from './masters/EmployeeDetails';
import EmployeeMasterForm from './masters/EmployeeMasterForm';
import PrimaryGoalDetails from './masters/PrimaryGoalDetails';
import PrimaryGoalMasterForm from './masters/PrimaryGoalMasterForm';
import PropertyTypeDetails from './masters/PropertyTypeDetails';
import PropertyTypeMasterForm from './masters/PropertyTypeMasterForm';
import SourceDetails from './masters/SourceDetails';
import SourceMasterForm from './masters/SourceMasterForm';
import TimelineDetails from './masters/TimelineDetails';
import TimelineMasterForm from './masters/TimelineMasterForm';
import EnquiryReports from './components/EnquiryReports';

// --- SECURITY GUARDS START ---

// १. जर लॉगिन नसेल तर थेट बाहेर काढण्यासाठी
const ProtectedRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user_data'));
  if (!user) return <Navigate to="/" replace />;
  return children;
};

// २. जर लॉगिन असलेला युजर Admin नसेल तर त्याला Master कडे जाण्यापासून रोखण्यासाठी
const AdminRoute = ({ children }) => {
  const user = JSON.parse(localStorage.getItem('user_data'));
  if (user?.role !== 1) return <Navigate to="/dashboard" replace />;
  return children;
};

// --- SECURITY GUARDS END ---

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* LOGIN */}
        <Route path="/" element={<Login />} />

        {/* MAIN LAYOUT (Wrapped in ProtectedRoute) */}
        <Route element={
          <ProtectedRoute>
            <Box sx={{ border: '10px solid #1f0b7c', height: '100vh', boxSizing: 'border-box' }}>
              <MainLayout />
            </Box>
          </ProtectedRoute>
        }>
          {/* COMMON PAGES (Accessible by Admin and User) */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/inquiry" element={<AddLeadForm />} />
          <Route path="/inquiry-details" element={<InquiryDetails />} />
          <Route path="/leads" element={<LeadContent />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/followup-report" element={<ReportPage />} />
           <Route path="/enquiry-report" element={<EnquiryReports />} />

          {/* MASTER PAGES (Only Admin - Role 1 can access) */}
          <Route path="/area-details" element={<AdminRoute><AreaDetails /></AdminRoute>} />
          <Route path="/area-master" element={<AdminRoute><AreaMasterForm /></AdminRoute>} />

          <Route path="/budget-details" element={<AdminRoute><BudgetDetails /></AdminRoute>} />
          <Route path="/budget-master" element={<AdminRoute><BudgetMasterForm /></AdminRoute>} />
          
          <Route path="/communication-details" element={<AdminRoute><CommunicationDetails /></AdminRoute>} />
          <Route path="/communication-master" element={<AdminRoute><CommunicationMasterForm /></AdminRoute>} />

          <Route path="/customer-details" element={<AdminRoute><CustomerDetails /></AdminRoute>} />
          <Route path="/customer-master" element={<AdminRoute><CustomerMasterForm /></AdminRoute>} />

          <Route path="/employee-details" element={<AdminRoute><EmployeeDetails /></AdminRoute>} />
          <Route path="/employee-master" element={<AdminRoute><EmployeeMasterForm /></AdminRoute>} />

          <Route path="/PrimaryGoal-details" element={<AdminRoute><PrimaryGoalDetails /></AdminRoute>} />
          <Route path="/PrimaryGoal-master" element={<AdminRoute><PrimaryGoalMasterForm /></AdminRoute>} />

          <Route path="/PropertyType-details" element={<AdminRoute><PropertyTypeDetails /></AdminRoute>} />
          <Route path="/PropertyType-master" element={<AdminRoute><PropertyTypeMasterForm /></AdminRoute>} />

          <Route path="/Source-details" element={<AdminRoute><SourceDetails /></AdminRoute>} />
          <Route path="/Source-master" element={<AdminRoute><SourceMasterForm /></AdminRoute>} />

          <Route path="/Timeline-details" element={<AdminRoute><TimelineDetails /></AdminRoute>} />
          <Route path="/Timeline-master" element={<AdminRoute><TimelineMasterForm /></AdminRoute>} />
        </Route>

        {/* DEFAULT */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;